import React from 'react';
import { useCurrentClientManager } from '@cko/dashboard-shared';
import { Modal, ModalBody } from '@cko/primitives';
import { Row } from './Row';

export const AccountDetailsModal = () => {
  const { client, entity } = useCurrentClientManager();
  return (
    <Modal title="Account details">
      <ModalBody>
        <Row label="Client ID" value={client.id} />
        {entity && <Row label="Entity ID" value={entity.id} />}
      </ModalBody>
    </Modal>
  );
};
